class Phase {
  id = null;
  title = "";
  description = "";

  createdby = null;
  updatedby = null;
}
export default Phase;
